import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var AlarmClockFilledSvg = function AlarmClockFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.277 3.987 3.262 7.926 2 6.688l4.015-3.939zm9.446 0 4.015 3.939L22 6.688l-4.015-3.939zM12 21.749a8.56 8.56 0 0 0 5.994-2.435 8.24 8.24 0 0 0 2.483-5.88c0-2.206-.893-4.32-2.483-5.88A8.56 8.56 0 0 0 12 5.118a8.56 8.56 0 0 0-5.994 2.436 8.24 8.24 0 0 0-2.483 5.88c0 2.205.893 4.32 2.483 5.88A8.56 8.56 0 0 0 12 21.749m-.892-13.13v5.252h4.015v-1.75h-2.23V8.62z",
    clipRule: "evenodd"
  }));
};
export var AlarmClockFilled = function AlarmClockFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: AlarmClockFilledSvg
  }));
};